// extracted by mini-css-extract-plugin
module.exports = {"page":"MultiPlayerInteraction_page__17uwJ","card":"MultiPlayerInteraction_card__rSfxy"};